(() => {
  if (customElements.get('ab-site-header')) return;
  class AbSiteHeader extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const toggle = this.querySelector('[data-ab-menu-toggle]');
      const navigation = toggle && this.querySelector(`#${CSS.escape(toggle.getAttribute('aria-controls'))}`);
      if (!toggle || !navigation) return;
      this.dataset.ready = 'true';
      toggle.hidden = false;
      const setOpen = open => {
        this.dataset.menuOpen = String(open);
        toggle.setAttribute('aria-expanded', String(open));
      };
      const close = focus => {
        setOpen(false);
        navigation.querySelectorAll('details[open]').forEach(details => details.open = false);
        if (focus) toggle.focus();
      };
      toggle.addEventListener('click', () => setOpen(toggle.getAttribute('aria-expanded') !== 'true'));
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
          event.preventDefault();
          close(true);
        }
      });
      navigation.addEventListener('click', event => {
        if (event.target.closest('a')) close(false);
      });
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) close(false);
      });
      setOpen(false);
    }
  }
  customElements.define('ab-site-header', AbSiteHeader);
})();
